import { Acl } from './acl';
import { Property } from './property';

export class Organization {
    public id: string;
    public display: string;
    public billing: string;
    public networks: string;
    public properties: Property[] = [];
    public rights: Acl[] = [];
    public enabled: boolean = true;
    public readonly createdAt: Date;
    public readonly updatedAt: Date;
    public readonly deletedAt: Date;
    public appData: string;
    public organizationId: string;
    public displayParentOrganization: string;
    public path: string;
    public fullPath: string;
    public country: string;
    public siren: string;
    public ownerId: string;
    public applicationId: string;
    public internalRef: string;
}
